import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { TabsField } from 'support/fields'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function WhoShouldHandleToggle ({ itemId }) {
  function generatePath (name) {
    return ['globals.inventory.order_items', itemId, name].join('.')
  }

  const [, setWhoShouldHandleOffset] = useEnvValue(generatePath('who_should_handle_offset'))

  return (
    <WhenModelValue name='received_offset' condition={v => !!v}>
      <TabsField
        name={`who_should_handle_offset[${itemId}]`}
        naked
        enum='who_should_handle_order_offset'
        onChange={value => setWhoShouldHandleOffset(value)}
        defaultValue='we_will'
      />
    </WhenModelValue>
  )
}
